import { render } from "./App.vue?vue&type=template&id=324dab4e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=324dab4e&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\recruitment-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324dab4e"]])

export default __exports__